import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Path, Config } from '../../enums';
import { CommonService } from '../../services/common.service';
import { UtilsService } from '../../services/utils.service';
import { TokenService } from '../../services/token.service';
import { AuthenticationService } from '../../modules/authentication/services/authentication.service';


@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
    error!: string;
    statusCodes: any;
    errorMsgConfig: any = {};

    constructor(
        private cmnSrv: CommonService,
        private utilSrv : UtilsService,
        private tokenservice : TokenService,
        private authSrv: AuthenticationService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(tap({
            next: () => {
                // do anything with the response if necessary
            },
            error: async (error) => {
                if (error instanceof HttpErrorResponse) {

                    this.errorMsgConfig = await this.cmnSrv.loadConfig({
                        path: Path.ERROR_MESSAGE_CONFIG_PATH,
                        configType: Config.ERROR_MESSAGE_CONFIG
                    })
                    
                    if (error.status === 401) {
                        this.utilSrv.logout();
                        return
                    } else {
                        const errorMessage = this.setError(error);
                        return throwError(() => errorMessage);
                    }
                } else {
                    return 
                }
            }
        }));
    }

    setError(err: HttpErrorResponse): string | Observable<any> {
        let errorMessage!: string;

        if (err.error instanceof ErrorEvent) {
            //client side error
            errorMessage = err.message
        } else {
            //server side error
            const loggedIn = this.authSrv.isLoggedIn();
            errorMessage = err.error.message ? err.error.message : this.errorMsgConfig?.[err?.status]?.message;

            if (err.status === 401) {
                this.tokenservice.showtoaster()
                return errorMessage;
            }

            if (err.status === 400 && loggedIn) {
                errorMessage = err.error.message ? { message: err.error.message, code: err.error.statusCode }: this.errorMsgConfig[err?.status]?.message;
            }

        }
        return errorMessage;
    }
}
